import Runtime from '../../Runtime'

export default (value) => {
    return !!value && (value instanceof Runtime.BSON.ObjectId || value._bsontype === 'ObjectID')
}